import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './EditApartmentUnit.css'; // Optional CSS

const EditApartmentUnit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    unitname: '',
    description: '',
    floornumber: '',
    rentamount: '',
    status: '',
    type: '',
  });
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUnit();
  }, []);

  const fetchUnit = async () => {
    try {
      const res = await axios.get(`https://ikaze-thouse-backend.vercel.app/api/v1/appartmentUnits/get/${id}`);
      if (res.data.success) {
        setFormData({
          unitname: res.data.data.unitname || '',
          description: res.data.data.description || '',
          floornumber: res.data.data.floornumber || '',
          rentamount: res.data.data.rentamount || '',
          status: res.data.data.status || '',
          type: res.data.data.type || '',
        });
      } else {
        setError(res.data.message || 'Failed to fetch unit');
      }
    } catch (err) {
      setError('Error fetching unit');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.put(`https://ikaze-thouse-backend.vercel.app/api/v1/appartmentUnits/update/${id}`, formData);
      if (res.data.success) {
        alert('Apartment unit updated successfully');
        navigate('/manager/apartment-units'); // Change this path if needed
      } else {
        setError(res.data.message || 'Update failed');
      }
    } catch (err) {
      setError('Error updating unit');
    }
  };

  return (
    <div className="edit-container">
      <h2>Edit Apartment Unit</h2>
      {error && <p className="text-danger">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Unit Name</label>
          <input
            type="text"
            name="unitname"
            value={formData.unitname}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Floor Number</label>
          <input
            type="number"
            name="floornumber"
            value={formData.floornumber}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Rent Amount</label>
          <input
            type="number"
            name="rentamount"
            value={formData.rentamount}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Status</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">-- Select Status --</option>
            <option value="Available">Available</option>
            <option value="Occupied">Occupied</option>
            <option value="Maintenance">Under Maintenance</option>
          </select>
        </div>
        <div>
          <label>Type</label>
          <input
            type="text"
            name="type"
            value={formData.type}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">Update</button>
      </form>
    </div>
  );
};

export default EditApartmentUnit;
